module.exports = __webpack_public_path__ + "static/media/UNLOCK BY KUNAL.ffa682a1.svg";